import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-dialog-modal',
    templateUrl: './dialog-modal.component.html',
    styleUrls: ['./dialog-modal.component.css'],
    standalone: true,
    imports: [CommonModule, MatButton],
})
export class DialogModalComponent {
    @Input() message: string = '';         // Use string for clarity
    @Input() class: string = '';            // Use string for clarity
    @Input() messageType: string = '';      // Use string for clarity
    @Input() iconClass: string = '';        // Use string for clarity
    @Input() isConfirmation: boolean = false; // Explicitly set as boolean

    constructor(public activeModal: NgbActiveModal) {} // Removed activeModal.close()

    close() {
        this.activeModal.dismiss('cancel'); // Use dismiss to indicate the modal was closed without confirmation
    }

    confirm(): void {
        this.activeModal.close(true); // Pass true to indicate confirmation
    }
}
